export const environment = {
    production: false,
    auto_fill: false,
    hmr: false,
    banner: `Base DEV`,
    version: '2026.0619.0836',

    BaseAvatarUrl: 'https://devbase.siriusfinance.cz/assets/images/PoradciObr',
    BaseApiUrl: 'https://devbaseapi.siriusfinance.cz/api',
    BaseAdvisorUrl: 'https://devbase.siriusfinance.cz/assets/images/PoradciObr',
    ApolloUrl: 'https://devapollo2.siriusfinance.cz',
    PortalUrl: 'https://devsso.siriusfinance.cz',

    SsoUrl: 'https://devsso.siriusfinance.cz',
    SsoAllowedUrls: ['https://devsso.siriusfinance.cz/', 'https://devbaseapi.siriusfinance.cz/', 'http://localhost:5000/'],
    SsoClientId: 'app-test-client',
    SsoDummyClientSecret: 'BeyKUpe9JA50L9e3rceZNF4BskIvtNmCzb6d1nvgxZAQ',
    SsoScope: 'openid profile roles advisor api_base offline_access',
};
